import styled from "styled-components";
import { themes } from "../../../Utils/themes";
import { device } from "../../../Utils/device";

export const LogoImg = styled.img`
  width: 128px;
  @media ${device.desktop} {
    display: none;
  }
`;

export const HamburgerMenuWrap = styled.div`
  position: fixed;
  height: 60px;
  width: 100%;
  padding: 17px;
  @media ${device.desktop} {
    display: none;
  }
`;

export const StyledBurger = styled.button`
  display: flex;
  justify-content: space-around;
  flex-flow: column nowrap;
  width: 1.5rem;
  height: 1.5rem;
  position: fixed;
  top: 15px;
  right: 20px;
  z-index: 20;
  border: none;
  cursor: pointer;
  background: transparent;
`;

export const StyledBurgerLine = styled.div<{ open: boolean }>`
  width: 1.5rem;
  height: 0.25rem;
  background-color: ${themes.colors.primary};
  border-radius: 10px;
  transform-origin: 2px;
  transition: all 0.3s linear;
  position: relative;

  &:nth-child(1) {
    transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
  }

  &:nth-child(2) {
    transform: ${({ open }) => (open ? "translateX(100%)" : "translateX(0)")};
    opacity: ${({ open }) => (open ? 0 : 1)};
  }

  &:nth-child(3) {
    transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
  }
`;

export const StyledMenu = styled.nav<{ open: boolean }>`
  flex-flow: column wrap;
  background-color: ${themes.colors.white};
  border: 1px solid ${themes.colors.border};
  position: fixed;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
  top: 0;
  right: 0;
  height: 100vh;
  list-style: none;
  display: flex;
  width: 100%;
  padding-top: 3.5rem;
  transition: transform 0.3s ease-in-out;
  align-items: center;
  z-index: 10;
  padding-top: 80px;
  gap: 45px;
  @media ${device.desktop} {
    display: none;
  }
`;

export const MenuItemWrap = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
`;

export const LinkIcon = styled.img`
  width: 25px;
  cursor: pointer;
`;
